import React from 'react';

import { Button, Flex, message, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';
import { useApiErrorMessage } from '@app/services/hooks/useApiErrorMessage';
import { RAW_INTERPOLATION } from '@app/services/i18n';

const CONFIRMED_MESSAGE_DURATION = 8;

interface IProps {
  invitationUid: string;
  email: string;
  onStale: () => void;
}

export const ConfirmInvitation: React.FC<IProps> = ({ invitationUid, email, onStale }) => {
  const [submitting, setSubmitting] = React.useState(false);
  const navigate = useNavigate();
  const pageT = useTranslation(NSKeys.counterpartyInvite);
  const getErrorMessage = useApiErrorMessage();

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await Api.users.acceptCounterpartyInvitation({ invitation_uuid: invitationUid });
      message.success(pageT.t('confirm.success'), CONFIRMED_MESSAGE_DURATION);
      navigate('/login', { replace: true });
    } catch (err) {
      message.error(getErrorMessage(err));
      onStale();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Flex vertical gap={16} align="flex-start">
      <Typography.Paragraph style={{ marginBottom: 0 }}>
        {pageT.t('confirm.description', { email, ...RAW_INTERPOLATION })}
      </Typography.Paragraph>
      <Button type="primary" loading={submitting} onClick={handleConfirm}>
        {pageT.t('confirm.submit')}
      </Button>
    </Flex>
  );
};
